export default {
  project: 'rex'
}